import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from '@firebase/app'
import '@firebase/auth'
import { getUrlFromText } from '../utils'

const RecipeView = () => import(/* webpackChunkName: "group-recipe" */ '@/views/RecipeView')
const SearchView = () => import(/* webpackChunkName: "group-recipe" */ '@/views/SearchView')
const Login = () => import(/* webpackChunkName: "group-auth" */ '@/views/Login')
const ResetPassword = () => import(/* webpackChunkName: "group-auth" */ '@/views/ResetPassword')

Vue.use(VueRouter)

const getUrlFromRoute = (route) =>
  getUrlFromText(route.query.url) ||
  getUrlFromText(route.query.text) ||
  null

var routes = [
  {
    path: '/login',
    meta: {
      ability: 'login',
      context: 'account',
      view: 'login',
      requireNoAuth: true
    },
    name: 'Login',
    component: Login
  }, {
    path: '/register',
    meta: {
      ability: 'register',
      context: 'account',
      view: 'login',
      mode: 'register',
      requireNoAuth: true
    },
    name: 'Register',
    component: Login
  }, {
    path: '/resetpassword',
    meta: {
      ability: 'resetpassword',
      context: 'account',
      view: 'resetpassword',
      requireNoAuth: true
    },
    name: 'ResetPassword',
    component: ResetPassword
  }, {
    component: RecipeView,
    meta: {
      ability: 'view',
      context: 'library',
      requireAuth: true,
      view: 'recipe'
    },
    name: 'Library',
    path: '/',
    props: (route) => ({
      url: getUrlFromRoute(route)
    })
  }, {
    component: RecipeView,
    meta: {
      ability: 'view',
      context: 'collection',
      requireAuth: true,
      view: 'recipe'
    },
    name: 'UserCollection',
    path: '/collections/:collectionKey/:recipeKeyGroup(recipes/[^/]+)?',
    props: (route) => ({
      collectionKey: route.params.collectionKey,
      recipeKey: route.params.recipeKeyGroup && route.params.recipeKeyGroup.match(/\/(.*)/)[1],
      url: getUrlFromRoute(route)
    })
  }, {
    component: SearchView,
    meta: {
      ability: 'view',
      context: 'search',
      requireAuth: true,
      view: 'search'
    },
    name: 'SearchCollection',
    path: '/search/:query?/:recipeKeyGroup(recipes/[^/]+)?',
    props: (route) => ({
      initialQuery: route.params.query,
      query: route.params.query,
      recipeKey: route.params.recipeKeyGroup && route.params.recipeKeyGroup.match(/\/(.*)/)[1]
    })
  }, {
    component: RecipeView,
    meta: {
      ability: 'view',
      context: 'collection',
      requireAuth: true,
      view: 'recipe'
    },
    name: 'SystemCollection',
    path: '/:collectionKey(library|favorites|uncategorized|pinned|recent|deleted)/:recipeKeyGroup(recipes/[^/]+)?',
    props: (route) => ({
      collectionKey: route.params.collectionKey,
      recipeKey: route.params.recipeKeyGroup && route.params.recipeKeyGroup.match(/\/(.*)/)[1]
    })
  }
]

/* eslint-disable no-new */
const router = new VueRouter({
  routes,
  scrollBehavior () {
    return {x: 0, y: 0}
  },
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requireAuth = to.matched.some(route => route.meta.requireAuth)
  let requireNoAuth = to.matched.some(route => route.meta.requireNoAuth)
  if (requireAuth && !currentUser) next('login')
  else if (requireNoAuth && currentUser) next('')
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js